import React from 'react';
import './App.css';
import { AuthGuard } from 'src/auth';
import LiveChatbot from './pages/LiveChatbot';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { MotionLazy } from 'src/components/animate/motion-lazy';

const theme = createTheme();

function App() {
  return (
      <ThemeProvider theme={theme}>
        <MotionLazy>
          <BrowserRouter>
            <Routes>
              <Route
                element={
                  <AuthGuard>
                    <LiveChatbot />
                  </AuthGuard>
                }
              >
                <Route index element={<LiveChatbot />} />
                <Route path="*" element={<div>Not found</div>} />
              </Route>
            </Routes>
          </BrowserRouter>
        </MotionLazy>
      </ThemeProvider>
  );
}

export default App;
